import { render } from "./AllOrders.vue?vue&type=template&id=121ba736"
import script from "./AllOrders.vue?vue&type=script&lang=js"
export * from "./AllOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/AllOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "121ba736"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('121ba736', __exports__)) {
    console.log('reload')
    api.reload('121ba736', __exports__)
  }
  
  module.hot.accept("./AllOrders.vue?vue&type=template&id=121ba736", () => {
    console.log('re-render')
    api.rerender('121ba736', render)
  })

}


export default __exports__